export const CORES = {
  principal1: "#21277B",
  principal2: "#006AD7",
  secundaria1: "#5F83B1",
  secundaria2: "#B9D3F2",
  secundaria3: "#FFA600",
};

export const ALTURA_BOTAO = 43;
